// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import frFR from 'antd/locale/fr_FR';
import { store } from './store';
import { GlobalStyles } from './styles/GlobalStyles';
import ProtectedRoute from './components/common/ProtectedRoute/ProtectedRoute';
import Layout from './components/common/Layout/Layout';
import LoginForm from './components/auth/LoginForm/LoginForm';
import Dashboard from './pages/Dashboard/Dashboard';
import DossierList from './components/dossiers/DossierList/DossierList';
import DossierForm from './components/dossiers/DossierForm/DossierForm';
import DossierDetail from './components/dossiers/DossierDetail/DossierDetail';
import UserManagement from './components/admin/UserManagement/UserManagement';
import DepartementManagement from './pages/References/DepartementManagement';
import GroupeClientManagement from './pages/References/GroupeClientManagement';
import TypologieManagement from './pages/References/TypologieManagement';
import Profile from './pages/Profile/Profile'; // NOUVEAU

const App: React.FC = () => {
  return (
    <>
      <GlobalStyles />
      <Provider store={store}>
        <ConfigProvider
          locale={frFR}
          theme={{
            token: {
              colorPrimary: '#722ed1',
              colorSuccess: '#52c41a',
              colorWarning: '#faad14',
              colorError: '#ff4d4f',
              borderRadius: 8,
              fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
              fontSize: 14,
              fontSizeHeading1: 28,
              fontSizeHeading2: 22,
              fontSizeHeading3: 18,
              fontSizeHeading4: 16,
              fontSizeHeading5: 14,
              fontWeightStrong: 600,
            },
          }}
        >
          <Router>
            <Routes>
              <Route path="/login" element={<LoginForm />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="profile" element={<Profile />} /> {/* NOUVEAU */}
                <Route path="dossiers" element={<DossierList />} />
                <Route path="dossiers/:id" element={<DossierDetail />} />
                <Route 
                  path="dossiers/new" 
                  element={<DossierForm mode="create" />} 
                />
                <Route 
                  path="dossiers/:id/edit" 
                  element={<DossierForm mode="edit" />} 
                />
                
                {/* Admin Routes */}
                <Route path="users" element={<UserManagement />} />
                <Route path="references/departements" element={<DepartementManagement />} />
                <Route path="references/groupe-clients" element={<GroupeClientManagement />} />
                <Route path="references/typologies" element={<TypologieManagement />} />
              </Route>
            </Routes>
          </Router>
        </ConfigProvider>
      </Provider>
    </>
  );
};

export default App;